import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const MyProviderHistoryPage = lazy(() => import("./MyProviderHistoryPage"));

const MyProviderHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MyProviderHistoryPage />
    </Suspense>
  );
};

export default MyProviderHistoryPageLazy;
